<template>
  <div style="position: relative">
    <div style="position: relative">
      <FilterFields
        :fields="[
          {
            type: 'text',
            label: 'Documento',
            field: 'documento',
          },
          {
            type: 'text',
            label: 'Fornecedor',
            field: 'fornecedor',
          },
          {
            type: 'text',
            label: 'Descrição',
            field: 'descricao',
          },
          {
            type: 'text',
            label: 'Meio Pag.',
            field: 'meio_pagamento',
          },
          {
            type: 'select',
            label: 'Status',
            field: 'status',
            options: ['Paga', 'Atrasada', 'Pendente', 'Agrupada', 'Atrasada e Pendente', 'Todos'],
          },
          {
            type: 'select',
            label: 'Marcada',
            field: 'conta_marcada',
            options: ['Sim', 'Não'],
          },
          {
            type: 'date',
            label: 'Vencimento',
            field: 'data_vencimento',
          },
          {
            type: 'date',
            label: 'Pagamento',
            field: 'data_pagamento',
          },
          {
            type: 'date',
            label: 'Emissão',
            field: 'created_at',
          },
          {
            type: 'text',
            label: 'Banco',
            field: 'banco',
          },
          {
            type: 'text',
            label: 'Plano de contas',
            field: 'plano_de_contas',
          },
          { type: 'text', label: 'R$ Valor', field: 'valor' },
        ]"
      />

      <div
        class="d-flex align-items-center my-2 mb-4"
        style="position: absolute; top: -7px; left: 110px; z-index: 99"
      >
        <b-dropdown
          :text="periodFilterLabel"
          split
          split-variant="secondary"
          id="menu"
          variant="primary"
          v-b-tooltip.right="''"
        >
          <b-dropdown-item
            :active="
              hasPeriodFilter && filtersStore.filterOptionSelected.id === 1
            "
            @click="
              () =>
                (filtersStore.filterOptionSelected = { id: 1, label: 'Hoje' })
            "
            >Hoje</b-dropdown-item
          >
          <b-dropdown-item
            :active="
              hasPeriodFilter && filtersStore.filterOptionSelected.id === 2
            "
            @click="
              () =>
                (filtersStore.filterOptionSelected = { id: 2, label: 'Ontem' })
            "
          >
            Ontem
          </b-dropdown-item>
          <b-dropdown-item
            :active="
              hasPeriodFilter && filtersStore.filterOptionSelected.id === 3
            "
            @click="
              () =>
                (filtersStore.filterOptionSelected = {
                  id: 3,
                  label: 'Essa semana',
                })
            "
          >
            Essa semana
          </b-dropdown-item>
          <b-dropdown-item
            :active="
              hasPeriodFilter && filtersStore.filterOptionSelected.id === 4
            "
            @click="
              () =>
                (filtersStore.filterOptionSelected = {
                  id: 4,
                  label: 'Semana passada',
                })
            "
          >
            Semana passada
          </b-dropdown-item>
          <b-dropdown-item
            :active="
              hasPeriodFilter && filtersStore.filterOptionSelected.id === 5
            "
            @click="
              () =>
                (filtersStore.filterOptionSelected = {
                  id: 5,
                  label: 'Esse mês',
                })
            "
          >
            Esse mês
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <b-dropdown
      id="menu"
      variant="dark"
      v-b-tooltip.right="'Mais ações'"
      v-if="actionsStore.selectedRows.length > 0"
      style="position: absolute; top: 0; left: 50px"
    >
      <template #button-content>
        <Menu :size="18" />
      </template>
      <b-dropdown-item v-b-modal.menuAcoes>Pagamento de Contas</b-dropdown-item>
      <b-dropdown-item @click="abrirAgrupamentoContas"
        >Agrupar contas</b-dropdown-item
      >
      <b-dropdown-item
        @click="() => getRequestAdmin(() => $bvModal.show('estornarContas'))"
        >Estornar Contas</b-dropdown-item
      >
      <b-dropdown-item v-b-modal.marcarContas
        >Marcar/Desmarcar Contas</b-dropdown-item
      >
      <b-dropdown-item
        v-b-modal.pagarParcial
        :disabled="actionsStore.selectedRows.length > 1"
        @click="
          () =>
            (dataVencimentoParcial =
              actionsStore.selectedRows[0].data_vencimento)
        "
        >Pagamento Parcial
      </b-dropdown-item>
    </b-dropdown>

    <b-modal
      id="estornarContas"
      title="Deseja estornar as Contas?"
      centered
      size="xs"
    >
      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="estornar"
            ref="estornar_contas"
            class="mr-5"
          >
            Estornar
          </b-button>
          <b-button
            @click="
              {
                actionsStore.updateTable = !actionsStore.updateTable;
                actionsStore.selectedRows = [];
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="marcarContas"
      title="Deseja marcar as Contas?"
      centered
      size="xs"
    >
      <p>
        Recurso utilizado para melhorar a visualização das contas selecionadas.
      </p>
      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="marcar"
            ref="marcarContas"
            class="mr-5"
          >
            Marcar
          </b-button>
          <b-button
            @click="
              {
                actionsStore.updateTable = !actionsStore.updateTable;
                actionsStore.selectedRows = [];
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal id="menuAcoes" title="Pagamentos em massa" centered size="xl">
      <b-form class="form">
        <div class="d-flex" style="max-height: 450px; overflow: auto">
          <b-table
            v-if="actionsStore.selectedRows.length > 0"
            striped
            small
            hover
            :items="pagamentoTableItems"
            :fields="actionTableFields"
          >
            <template #cell(actions)="row">
              <button
                type="button"
                class="btn btn-sm btn-danger btn-hover-danger btn-icon mr-2"
                @click="() => handleRemoveContaAPagar(row)"
              >
                <TrashCanIcon :size="16" />
              </button>
            </template>
          </b-table>
        </div>
      </b-form>
      <template #modal-footer="{ ok, cancel }">
        <div class="d-flex">
          <DatePickerInput
            label="Data de pagamento"
            @valueUpdated="
              (date) => {
                dataPagamento = date;
              }
            "
            mode="single"
          />
          <b-form-group
            id="bancoPagamento"
            label-for="bancoPagamento"
            label="Conta"
            class="mr-5"
          >
            <b-form-select v-model="bancoPagamento">
              <b-form-select-option
                v-for="b in bancos"
                :key="b.id_banco + 'bancos'"
                :value="b"
              >
                {{ b.nome }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
          <b-form-group
            id="meioPagamento"
            label-for="meioPagamento"
            label="Meio de pagamento"
          >
            <b-form-select v-model="meioPagamento">
              <b-form-select-option
                v-for="meio in meiosPagamentos"
                :key="meio.id + 'meio'"
                :value="meio"
              >
                {{ meio.descricao }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
          <b-form-group
            label="Total do pagamento R$"
            label-for="totalPagamento"
            class="ml-5"
          >
            <money
              class="form-control"
              id="totalPagamento"
              name="totalPagamento"
              :value="totalPagamento"
              disabled
              v-bind="configMask"
            >
            </money>
          </b-form-group>
        </div>
        <div>
          <b-button
            variant="primary"
            @click="pagarContas"
            ref="pagar_contas"
            class="mr-5"
          >
            Pagar
          </b-button>
          <b-button
            @click="
              {
                actionsStore.updateTable = !actionsStore.updateTable;
                actionsStore.selectedRows = [];
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="agruparContas"
      title="Agrupar contas a pagar"
      centered
      size="xl"
    >
      <b-form class="form">
        <div class="d-flex" style="max-height: 450px; overflow: auto">
          <b-table
            v-if="actionsStore.selectedRows.length > 0"
            striped
            small
            hover
            :items="agrupamentoTableItems"
            :fields="actionTableFields"
          >
            <template #cell(actions)="row">
              <button
                type="button"
                class="btn btn-sm btn-danger btn-hover-danger btn-icon mr-2"
                v-b-tooltip.hover.bottom="'Excluir'"
                @click="() => handleRemoveContaAPagar(row)"
              >
                <TrashCanIcon :size="16" />
              </button>
            </template>
          </b-table>
        </div>
      </b-form>
      <template #modal-footer="{ ok, cancel }">
        <div class="d-flex">
          <DatePickerInput
            label="Vencimento da nova conta"
            @valueUpdated="
              (date) => {
                dataVencimentoAgrupamento = date;
              }
            "
            mode="single"
          />
          <b-form-group
            id="bancoAgrupamento"
            label-for="bancoAgrupamento"
            label="Conta"
            class="mr-5"
          >
            <b-form-select v-model="bancoAgrupamento">
              <b-form-select-option
                v-for="b in bancos"
                :key="b.id_banco + 'bancosAgrupamento'"
                :value="b"
              >
                {{ b.nome }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
          <b-form-group
            id="meioPagamentoAgrupamento"
            label-for="meioPagamentoAgrupamento"
            label="Meio de pagamento"
          >
            <b-form-select v-model="meioPagamentoAgrupamento">
              <b-form-select-option
                v-for="meio in meiosPagamentos"
                :key="meio.id + 'meioAgrupamento'"
                :value="meio"
              >
                {{ meio.descricao }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>

          <b-form-group
            label="Total agrupado R$"
            label-for="totalAgrupamento"
            class="ml-5"
          >
            <money
              class="form-control"
              id="totalAgrupamento"
              name="totalAgrupamento"
              :value="totalAgrupamento"
              disabled
              v-bind="configMask"
            />
          </b-form-group>

          <b-form-group
            label="Desconto R$"
            label-for="descontoAgrupamento"
            class="ml-3"
          >
            <money
              class="form-control"
              id="descontoAgrupamento"
              name="descontoAgrupamento"
              v-model.number="descontoAgrupamento"
              v-bind="configMask"
              :masked="false"
            />
          </b-form-group>
        </div>
        <div>
          <b-button
            variant="primary"
            @click="agruparContas"
            ref="agrupar_contas"
            class="mr-5"
          >
            Agrupar
          </b-button>
          <b-button
            @click="
              {
                resetAgrupamentoData();
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="modalEscolherModelo"
      title="Escolha o modelo de exportação"
      centered
      size="md"
      hide-footer
    >
      <div class="mb-3 text-center text-muted" style="font-size: 15px">
        <strong>Atenção:</strong> Serão exportados somente os dados atualmente
        <br />
        <span class="text-success font-weight-bold">listados em tela</span>,
        conforme filtros aplicados.
      </div>
      <div class="d-flex flex-column align-items-center">
        <b-button variant="primary" class="mb-2" @click="exportarXLS('nuts')">
          Modelo Default
        </b-button>
        <b-button variant="secondary" @click="exportarXLS('questor')">
          Modelo Questor
        </b-button>
      </div>
    </b-modal>

    <b-tooltip target="menu" placement="right" :show.sync="showTooltipMenu">
      Pagamentos de contas
    </b-tooltip>
    <b-button
      class="ml-2 border border-muted"
      variant="success"
      v-b-tooltip.hover.right="'Exportar para Excel'"
      style="position: absolute; right: 13px; top: 2px"
      @click="$bvModal.show('modalEscolherModelo')"
    >
      <FileExcel :size="18" />
    </b-button>
    <TableApp
      titulo="Contas a Pagar"
      subTitulo="Lista de Contas a Pagar"
      acaoBtn="/#/contasPagar/novo"
      textoBtn="Nova"
      api-url="/contapagar"
      :fields="fields"
      classFilterColumn="historico"
      ref="contaPagar"
      :perPage="10"
      :multiselect="true"
    >
      <template slot="customRow" scope="props">
        <span slot="documento" v-if="props.field == 'documento'">
          <span class="pl-0 pt-8">
            <div class="d-flex align-items-center">
              <div>
                <a
                  class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
                  >{{ props.rowData.documento }}</a
                >
                <span class="text-muted font-weight-bold d-block">{{
                  props.rowData.historico
                }}</span>
                <span v-if="props.rowData.plano_contas" class="text-muted d-block" style="font-size: 0.8rem">
                  {{ props.rowData.plano_contas.descricao }}
                </span>
              </div>
            </div>
          </span>
        </span>
        <template v-if="props.field == 'fornecedor'">
          <div class="pl-0 pt-8">
            <div>
              <span class="text-muted font-weight-bold d-block">
                {{ props.rowData.fornecedor }}
              </span>
              <span
                v-if="props.rowData.cnpj_cpf"
                class="text-muted d-block"
                style="font-size: 0.85rem; cursor: pointer"
                @click="copyToClipboard(props.rowData.cnpj_cpf)"
                title="Clique para copiar"
              >
                {{ formatCpfCnpj(props.rowData.cnpj_cpf) }}
              </span>
            </div>
          </div>
        </template>
        <span slot="created_at" v-if="props.field == 'created_at'">
          <div class="font-weight-bold text-muted">
            {{ formatDate(props.rowData.created_at) }}
          </div>
        </span>
        <span slot="data_vencimento" v-if="props.field == 'data_vencimento'">
          <div class="font-weight-bold text-muted">
            {{ formatDate(props.rowData.data_vencimento) }}
          </div>
        </span>
        <span slot="data_pagamento" v-if="props.field == 'data_pagamento'">
          <div
            class="font-weight-bold text-muted"
            v-if="props.rowData.data_pagamento != null"
          >
            {{ formatDate(props.rowData.data_pagamento) }}
          </div>
        </span>
        <span slot="valor" v-if="props.field == 'valor'">
          <div
            v-if="props.rowData.valor_total > 0"
            v-b-tooltip="
              'Conta está calculando Juros: Valor Orignal + Juros + Multa - Desconto'
            "
          >
            <span class="text-dark-75 font-weight-bolder d-block font-size-lg"
              >R$
              {{ numberToReal(props.rowData.valor_total, 2) }}
            </span>
            <span
              class="text-muted font-weight-bold d-block"
              style="font-size: 12px"
            >
              R$ {{ numberToReal(props.rowData.valor, 2) }} +
              {{ numberToReal(props.rowData.juros, 2) }} +
              {{ numberToReal(props.rowData.multa, 2) }} -
              {{ numberToReal(props.rowData.desconto, 2) }}
            </span>
          </div>
          <span
            class="text-dark-75 font-weight-bolder d-block font-size-lg"
            v-else
            >R$
            {{ numberToReal(props.rowData.valor, 2) }}
          </span>
        </span>
        <span slot="meio_pagamento" v-if="props.field == 'meio_pagamento'">
          <span class="pl-0 pt-8">
            <div class="d-flex align-items-center">
              <span class="text-muted font-weight-bold d-block">{{
                props.rowData.meio_pagamento
              }}</span>
              <span v-if="props.rowData.id_conciliacao_bancaria || props.rowData.foi_conciliado_ofx" class="ml-2" style="display: inline-block" v-b-tooltip.hover.bottom="'Conciliado via OFX'">
                <CheckCircle :size="14" class="text-success" />
              </span>
            </div>
          </span>
        </span>
        <span slot="status" v-if="props.field == 'status'">
          <div class="d-flex align-items-center">
            <div v-html="onRowStatus(props.rowData)"></div>
            <span
              v-if="props.rowData.agrupada"
              class="agrupamento-info ml-2"
              v-b-tooltip.hover.bottom="
                'Documento gerado no agrupamento: ' +
                getDocumentoAgrupamento(props.rowData)
              "
            >
              !
            </span>
          </div>
        </span>
        <span slot="actions" v-if="props.field == 'actions'">
          <div class="row-actions" style="text-align: right !important">
            <span style="overflow: visible; position: relative; width: 130px">
              <div class="dropdown dropdown-inline">
                <router-link
                  v-if="!props.rowData.data_pagamento && !props.rowData.agrupada"
                  class="btn btn-sm btn-info btn-hover-info btn-icon mr-2"
                  :to="{
                    name: 'contasPagarEditar',
                    params: {
                      id: props.rowData.id,
                    },
                  }"
                >
                  <Pencil :size="16" title="Editar" />
                </router-link>
                <button
                  v-if="
                    props.rowData.id_empresa &&
                    !props.rowData.data_pagamento &&
                    !props.rowData.agrupada
                  "
                  @click="excluir(props.rowData)"
                  class="btn btn-sm btn-danger btn-hover-danger btn-icon mr-2"
                >
                  <TrashCanIcon :size="16" />
                </button>
              </div>
            </span>
          </div>
        </span>
      </template>
    </TableApp>
    <b-modal
      id="pagarParcial"
      title="Pagamento parcial de Conta?"
      centered
      size="lg"
      v-if="actionsStore.selectedRows.length > 0"
    >
      <b-row class="mb-4">
        <b-col>
          <b-form-checkbox
            name="nfe-saida"
            switch
            size="lg"
            v-model="descontoParcial"
          >
            Pagar Parcial / Desconto
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group id="documento" label-for="documento" label="Documento">
            <b-form-input
              :value="actionsStore.selectedRows[0]?.documento"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fornecedor"
            label-for="fornecedor"
            label="Fornecedor"
          >
            <b-form-input
              :value="actionsStore.selectedRows[0]?.fornecedor"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="data_vencimento"
            label-for="data_vencimento"
            label="Vencimento"
          >
            <b-form-input
              :value="formatDate(actionsStore.selectedRows[0]?.data_vencimento)"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="data_pagamento"
            label-for="data_pagamento"
            label="Pagamento"
          >
            <b-form-input
              :value="formatDate(actionsStore.selectedRows[0]?.data_pagamento)"
              disabled
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group id="valor" label-for="valor" label="Valor R$">
            <b-form-input
              :value="
                numberToReal(
                  parseFloat(actionsStore.selectedRows[0]?.valor ?? 0),
                  2
                )
              "
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group id="juros" label-for="juros" label="Juros R$">
            <b-form-input
              :value="
                numberToReal(
                  parseFloat(actionsStore.selectedRows[0]?.juros ?? 0),
                  2
                )
              "
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group id="multa" label-for="multa" label="Multa R$">
            <b-form-input
              :value="
                numberToReal(
                  parseFloat(actionsStore.selectedRows[0]?.multa ?? 0),
                  2
                )
              "
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group id="desconto" label-for="desconto" label="Desconto R$">
            <b-form-input
              :value="
                numberToReal(
                  parseFloat(actionsStore.selectedRows[0]?.desconto ?? 0),
                  2
                )
              "
              disabled
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="border-bottom">
        <b-col md="3">
          <b-form-group
            id="valor_total"
            label-for="valor_total"
            label="Vlr. Receber R$"
          >
            <b-form-input
              :value="
                numberToReal(
                  parseFloat(actionsStore.selectedRows[0]?.valor_total ?? 0),
                  2
                )
              "
              disabled
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col>
          <b-form-group
            id="dataVencimento"
            label-for="dataVencimento"
            label="Data Vencimento"
          >
            <b-form-datepicker
              v-model="dataVencimentoParcial"
              locale="pt-br"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="dataPagamento"
            label-for="dataPagamento"
            label="Data Pagamento"
          >
            <b-form-datepicker
              v-model="dataPagamentoParcial"
              locale="pt-br"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="bancoRecebimento"
            label-for="bancoRecebimento"
            label="Conta"
            class="mr-5"
          >
            <b-form-select v-model="contaParcial">
              <b-form-select-option
                v-for="b in bancos"
                :key="b.id_banco + 'bancos'"
                :value="b"
              >
                {{ b.nome }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="meioPagamento"
            label-for="meioPagamento"
            label="Meio de pagamento"
          >
            <b-form-select v-model="meioPagamentoParcial">
              <b-form-select-option
                v-for="meio in meiosPagamentos"
                :key="meio.id + 'meio'"
                :value="meio"
              >
                {{ meio.descricao }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="3">
          <b-form-group label="Valor Pago R$" label-for="valor_parcial">
            <money
              class="form-control"
              id="valor_parcial"
              name="valor_parcial"
              v-model="valorParcial"
              v-bind="configMask"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="valorParcial > 0">
        <b-col v-if="!descontoParcial">
          Você irá gerar uma nova conta à receber no valor de
          <span class="font-weight-bold text-primary"
            >R${{ numberToReal(parcialValueToDisplay - valorParcial) }}</span
          >
          ?
        </b-col>
        <b-col v-else>
          Você deseja gerar desconto no valor de
          <span class="font-weight-bold text-primary"
            >R${{ numberToReal(parcialValueToDisplay - valorParcial, 2) }}</span
          >
          ?
        </b-col>
      </b-row>
      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="pagarParcial"
            ref="pagar_parcial"
            class="mr-5"
          >
            Pagar
          </b-button>
          <b-button
            @click="
              {
                resetParcialData();
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>
    <Chart endpoint="/contapagar/total" modulo="contapagar" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Pencil from "vue-material-design-icons/Pencil.vue";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import CheckCircle from "vue-material-design-icons/CheckCircle.vue";
import TableApp from "@/components/Table/Table2";
import { SistemaMixin } from "@/modules/Application";
import Chart from "@/components/Charts/Charts.vue";
import FilterFields from "@/components/FilterFields";
import { actionsStore } from "@/components/Table/actionsStore";
import Menu from "vue-material-design-icons/Menu";
import { Money } from "v-money";
import { MONEY as settingMoney } from "@/modules/Application";
import DatePickerInput from "@/components/DatePickerInput/index.vue";
import { filtersStore } from "@/components/FilterFields/filtersStore";
import FileExcel from "vue-material-design-icons/FileExcel.vue";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "app-conta-pagar",
  mixins: [SistemaMixin],
  components: {
    Pencil,
    TrashCanIcon,
    CheckCircle,
    TableApp,
    Chart,
    FilterFields,
    Menu,
    Money,
    DatePickerInput,
    FileExcel,
  },
  data() {
    return {
      actionsStore,
      filtersStore,
      resumo: {},
      configMask: settingMoney,
      meioPagamento: null,
      meiosPagamentos: [],
      bancoPagamento: null,
      showTooltipMenu: false,
      dataPagamento: null,
      bancos: [
        {
          id_banco: 99999,
          nome: "Movimento Caixa",
        },
      ],
      fields: [
        {
          label: "Documento",
          field: "documento",
          type: "text",
          sortable: false,
          slot: true,
          filterOptions: {
            enabled: false,
            placeholder: "Filtrar Documento",
          },
          width: "10%",
        },
        {
          label: "Fornecedor",
          field: "fornecedor",
          type: "text",
          slot: true,
          sortable: false,
          filterOptions: {
            enabled: false,
            placeholder: "Filtrar Fornecedor",
          },
          width: "20%",
        },
        {
          label: "Emissão",
          field: "created_at",
          type: "date",
          filterable: true,
          slot: true,
          dateInputFormat: "yyyy-MM-dd",
          dateOutputFormat: "dd-MM-yyyy",
          width: "8%",
        },
        {
          label: "Vencimento",
          field: "data_vencimento",
          filterable: true,
          slot: true,
          type: "date",
          dateInputFormat: "yyyy-MM-dd",
          dateOutputFormat: "dd-MM-yyyy",
          filterOptions: {
            enabled: false,
            placeholder: "Data",
            filterFn: this.dateRangeFilter,
          },
          width: "8%",
        },
        {
          label: "Pagamento",
          field: "data_pagamento",
          slot: true,
          type: "date",
          dateInputFormat: "yyyy-MM-dd",
          dateOutputFormat: "dd-MM-yyyy",
          width: "8%",
        },
        {
          label: "Valor",
          field: "valor",
          slot: true,
          width: "12%",
        },
        {
          label: "M.Pag",
          field: "meio_pagamento",
          slot: true,
          width: "15%",
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: "Status",
          field: "status",
          slot: true,
          filterOptions: {
            enabled: false,
            placeholder: "Todas",
            filterDropdownItems: ["À pagar", "Paga", "Atrasada"],
          },
        },
        {
          label: "Ações",
          field: "actions",
          sortable: false,
          slot: true,
          width: "10%",
        },
      ],
      actionTableFields: [
        {
          key: "documento",
          label: "Documento",
        },
        {
          key: "cliente",
          label: "Cliente",
        },
        {
          key: "vencimento",
          label: "Vencimento",
        },
        {
          key: "pagamento",
          label: "Pagamento",
        },
        {
          key: "valor",
          label: "Valor R$",
        },
        {
          key: "juros",
          label: "Juros R$",
        },
        {
          key: "multa",
          label: "Multa R$",
        },
        {
          key: "desconto",
          label: "Desconto R$",
        },
        {
          key: "valor_total",
          label: "Vlr. Receber R$",
        },
        {
          key: "status",
          label: "Status",
        },
        {
          key: "actions",
          label: "",
        },
      ],
      dataVencimentoParcial: null,
      descontoParcial: false,
      dataPagamentoParcial: null,
      contaParcial: null,
      meioPagamentoParcial: null,
      valorParcial: 0,
      meioPagamentoAgrupamento: null,
      bancoAgrupamento: null,
      dataVencimentoAgrupamento: null,
      descontoAgrupamento: 0,
    };
  },
  methods: {
    exportarXLS(modelo) {
      const dadosVisiveis = this.$refs.contaPagar.data;
      let dados;

      if (modelo === "questor") {
        dados = dadosVisiveis.map((item) => ({
          FIXO: "C",
          CODIGOESTAB: this.currentUser.usuario_empresa.empresa.cnpj_cpf,
          DATACTOCTB: this.formatDate(item.data_pagamento),
          NUMERODCTO: item.documento,
          CONTACTBDEB: "",
          CONTACTBCRED:
            item.plano_contas.id + "-" + item.plano_contas.descricao,
          VALOLCTOCTB: this.numberToReal(item.valor),
          CODHIST: item.id_plano_contas,
          COMPLHIST: "0000",
        }));
      }

      if (modelo === "nuts") {
        dados = dadosVisiveis.map((item) => ({
          Documento: item.documento,
          Histórico: item.historico,
          Fornecedor: item.fornecedor,
          Emissão: this.formatDate(item.created_at),
          Vencimento: this.formatDate(item.data_vencimento),
          Pagamento: this.formatDate(item.data_pagamento),
          Valor: this.numberToReal(item.valor),
        }));
      }

      const ws = XLSX.utils.json_to_sheet(dados);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Contas a Pagar");

      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });
      this.$bvModal.hide("modalEscolherModelo");

      saveAs(blob, "contas_a_pagar.xlsx");
    },
    getVisibleItems() {
      return this.filteredRows || this.items; // use o nome correto do array visível
    },
    copyToClipboard(text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.$toast.success("Conteúdo copiado com sucesso!");
        })
        .catch(() => {
          this.$toast.error("Não foi possível copiar");
        });
    },
    dateRangeFilter(data_vencimento, filterString) {
      let dateRange = filterString.split("to");
      let startDate = Date.parse(dateRange[0]);
      let endDate = Date.parse(dateRange[1]);
      return (data_vencimento =
        Date.parse(data_vencimento) >= startDate &&
        Date.parse(data_vencimento) <= endDate);
    },
    async getDataInit() {
      const bancos = await this.getBancosByEmpresa();
      this.bancos.push(...bancos);
      this.bancoPagamento = this.bancos[0];
      const response = await this.$http.post("/financeiro/meios-pagamento");
      this.meiosPagamentos = response.data;
      this.meioPagamento = this.meiosPagamentos[0];
      this.bancoAgrupamento = this.bancos[0];
      this.meioPagamentoAgrupamento = this.meiosPagamentos[0];
    },
    handleRemoveContaAPagar({ index }) {
      this.actionsStore.selectedRows = this.actionsStore.selectedRows.filter(
        (row, rowIndex) => index !== rowIndex
      );
    },
    async pagarContas() {
      this.addLoadingToButton("pagar_contas");
      try {
        await this.$http.post("/contapagar/pagamento", {
          id_banco: this.bancoPagamento.id_banco,
          id_meio_pagamento: this.meioPagamento.id,
          data_pagamento: this.dataPagamento,
          contas_pagar: this.actionsStore.selectedRows.map((conta) => ({
            id: conta.id,
          })),
        });
        this.actionsStore.selectedRows = [];
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.meioPagamento = null;
        this.bancoPagamento = null;
        this.$toast.success("Contas paga com sucesso!");
        this.$refs.contaPagar.refresh();
        this.$bvModal.hide("menuAcoes");
      } catch (error) {
        console.log(error);
        this.meioPagamento = null;
        this.bancoPagamento = null;
        this.$bvModal.hide("menuAcoes");
      }
      this.removeLoadingToButton("pagar_contas");
    },
    onRowStatus(dataItem, onlyLabel = false) {
      if (dataItem.agrupada) {
        return !onlyLabel
          ? '<span class="label label-lg label-light-primary label-inline">Agrupada</span>'
          : "Agrupada";
      }
      if (
        dataItem.data_vencimento < this.thisDate() &&
        dataItem.data_pagamento === null
      ) {
        return !onlyLabel
          ? '<span class="label label-lg label-light-danger label-inline">Atrasada</span>'
          : "Atrasada";
      }
      if (
        dataItem.data_vencimento > this.thisDate() &&
        dataItem.data_pagamento === null
      ) {
        return !onlyLabel
          ? '<span class="label label-lg label-light-warning label-inline">Pendente</span>'
          : "Pendente";
      }
      if (dataItem.pago == true) {
        return !onlyLabel
          ? '<span class="label label-lg label-light-success label-inline">Paga</span>'
          : "Paga";
      }

      return "";
    },
    excluir(data) {
      this.getRequestAdmin(() => {
        this.$swal
          .fire({
            icon: "warning",
            title: "Excluir o lançamento: " + data.historico + "?",
            showCancelButton: true,
            confirmButtonText: `Sim`,
            cancelButtonText: `Não`,
            confirmButtonColor: "#f64e60",
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              await this.$http.post("/contapagar/delete", {
                id: data.id,
              });
              this.$refs.contaPagar.refresh();
              this.$toast.success("Lançamento excluído!");
            }
          });
      });
    },
    async estornar() {
      this.addLoadingToButton("estornar_contas");
      try {
        await this.$http.post("/contapagar/estornar", {
          contas_pagar: this.actionsStore.selectedRows.map((conta) => ({
            id: conta.id,
          })),
        });
        this.actionsStore.selectedRows = [];
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$toast.success("Contas estornadas com sucesso!");
        this.$refs.contaPagar.refresh();
        this.$bvModal.hide("menuAcoes");
        this.$bvModal.hide("estornarContas");
      } catch (error) {
        this.$bvModal.hide("estornarContas");
      }
      this.removeLoadingToButton("estornar_contas");
    },
    async marcar() {
      this.addLoadingToButton("marcarContas");
      try {
        await this.$http.post("/contapagar/marcar", {
          contas_pagar: this.actionsStore.selectedRows.map((conta) => ({
            id: conta.id,
          })),
        });
        this.actionsStore.selectedRows = [];
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$toast.success("Contas marcadas com sucesso!");
        this.$refs.contaPagar.refresh();
        this.$bvModal.hide("menuAcoes");
        this.$bvModal.hide("marcarContas");
      } catch (error) {
        this.$bvModal.hide("marcarContas");
      }
      this.removeLoadingToButton("marcarContas");
    },
    async pagarParcial() {
      const contaReceberData = this.actionsStore.selectedRows[0];

      if (
        !this.dataPagamentoParcial ||
        !this.contaParcial ||
        !this.meioPagamentoParcial ||
        !this.valorParcial
      ) {
        this.$toast.error("Preencha todos os campos necessários!");
        return;
      }
      this.addLoadingToButton("pagar_parcial");
      try {
        const { data: dataToSend } = await this.$http.post(
          "/contapagar/pagar-parcial",
          {
            id_conta_pagar: contaReceberData.id,
            valor_parcial: this.valorParcial,
          }
        );
        const response = await this.$http.post("/contapagar/create-parcial", {
          ...dataToSend,
          data_vencimento: this.dataVencimentoParcial,
          data_pagamento: this.dataPagamentoParcial,
          id_banco: this.contaParcial.id_banco,
          id_meio_pagamento: this.meioPagamentoParcial.id,
          valor_parcial: this.valorParcial,
          desconto: this.descontoParcial,
        });
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("pagar_parcial");
      this.resetParcialData();
      this.$bvModal.hide("pagarParcial");
    },
    resetParcialData() {
      this.dataPagamentoParcial = null;
      this.dataVencimentoParcial = null;
      this.descontoParcial = false;
      this.contaParcial = null;
      this.meioPagamentoParcial = null;
      this.valorParcial = 0;
      this.actionsStore.updateTable = !this.actionsStore.updateTable;
      this.actionsStore.selectedRows = [];
    },
    _unmaskMoney(val) {
      if (val == null) return 0;
      if (typeof val === "number") return val;
      const str = String(val)
        .replace(/\s/g, "")
        .replace(/\./g, "")
        .replace(",", ".");
      const n = parseFloat(str);
      return isNaN(n) ? 0 : n;
    },
    isContaDisponivelParaPagamento(conta) {
      const status = this.onRowStatus(conta, true);
      return status !== "Paga" && status !== "Agrupada";
    },
    getDocumentoAgrupamento(dataItem) {
      return dataItem.documento_agrupamento || "não informado";
    },
    abrirAgrupamentoContas() {
      const contasSelecionadas = this.actionsStore.selectedRows || [];
      const contasValidas = contasSelecionadas.filter((conta) =>
        this.isContaDisponivelParaPagamento(conta)
      );

      if (contasValidas.length < 2) {
        this.$toast.error("Selecione ao menos duas contas em aberto.");
        return;
      }

      if (contasValidas.length !== contasSelecionadas.length) {
        this.$toast.warning(
          "Contas pagas ou já agrupadas não serão agrupadas."
        );
      }

      const primeiroFornecedor = contasValidas[0].id_pessoa || null;
      const fornecedorDiferente = contasValidas.some(
        (conta) => (conta.id_pessoa || null) !== primeiroFornecedor
      );

      if (fornecedorDiferente) {
        this.$toast.error("Selecione contas do mesmo fornecedor para agrupar.");
        return;
      }

      this.actionsStore.selectedRows = contasValidas;

      if (!this.bancoAgrupamento) {
        this.bancoAgrupamento = this.bancos[0];
      }
      if (!this.meioPagamentoAgrupamento) {
        this.meioPagamentoAgrupamento = this.meiosPagamentos[0];
      }

      this.$nextTick(() => this.$bvModal.show("agruparContas"));
    },
    resetAgrupamentoData() {
      this.dataVencimentoAgrupamento = null;
      this.bancoAgrupamento = this.bancos[0] || null;
      this.meioPagamentoAgrupamento = this.meiosPagamentos[0] || null;
      this.descontoAgrupamento = 0;
      this.actionsStore.updateTable = !this.actionsStore.updateTable;
      this.actionsStore.selectedRows = [];
    },
    validarAgrupamentoContas() {
      if (this.actionsStore.selectedRows.length < 2) {
        this.$toast.error("Selecione ao menos duas contas para agrupar.");
        return false;
      }

      if (
        !this.dataVencimentoAgrupamento ||
        !this.bancoAgrupamento ||
        !this.meioPagamentoAgrupamento
      ) {
        this.$toast.error("Preencha todos os campos necessários.");
        return false;
      }

      const desconto = this._unmaskMoney(this.descontoAgrupamento);

      if (desconto >= this.totalAgrupamentoBruto) {
        this.$toast.error("O desconto deve ser menor que o total agrupado.");
        return false;
      }

      return true;
    },
    async agruparContas() {
      if (!this.validarAgrupamentoContas()) {
        return;
      }

      this.addLoadingToButton("agrupar_contas");
      try {
        await this.$http.post("/contapagar/agrupar-contas", {
          id_banco: this.bancoAgrupamento.id_banco,
          id_meio_pagamento: this.meioPagamentoAgrupamento.id,
          data_vencimento: this.dataVencimentoAgrupamento,
          desconto: this._unmaskMoney(this.descontoAgrupamento),
          contas_pagar: this.actionsStore.selectedRows.map((conta) => ({
            id: conta.id,
          })),
        });
        this.$toast.success("Contas agrupadas com sucesso!");
        this.$refs.contaPagar.refresh();
        this.$bvModal.hide("agruparContas");
        this.resetAgrupamentoData();
      } catch (error) {
        const mensagem =
          error?.response?.data?.msg || "Não foi possível agrupar as contas.";
        this.$toast.error(mensagem);
      } finally {
        this.removeLoadingToButton("agrupar_contas");
      }
    },
  },
  watch: {
    "filtersStore.filterOptionSelected": {
      handler(value) {
        switch (value.id) {
          case 1:
            this.getCurrentDayData("contasPagar");
            break;
          case 2:
            this.getYesterdayData("contasPagar");
            break;
          case 3:
            this.getCurrentWeekData("contasPagar");
            break;
          case 4:
            this.getLastWeekData("contasPagar");
            break;
          case 5:
            this.getMonthData("contasPagar");
            break;
          default:
            break;
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked", "currentUser"]),
    config() {
      return this.layoutConfig();
    },
    hasPeriodFilter() {
      return Boolean(
        filtersStore.contasPagar.filters.range_data_vencimento?.length
      );
    },
    periodFilterLabel() {
      return this.hasPeriodFilter
        ? filtersStore.filterOptionSelected.label
        : "Período";
    },
    parcialValueToDisplay() {
      if (actionsStore.selectedRows.length === 0) {
        return 0;
      }
      if (actionsStore.selectedRows[0].valor_total > 0) {
        return parseFloat(actionsStore.selectedRows[0].valor_total);
      }
      return parseFloat(actionsStore.selectedRows[0].valor);
    },
    pagamentoTableItems() {
      if (actionsStore.selectedRows.length === 0) return [];
      return actionsStore.selectedRows
        .map((row) => ({
          documento: row.documento,
          cliente: row.cliente,
          vencimento: row.data_vencimento,
          pagamento: row.data_pagamento,
          valor: this.numberToReal(row.valor, 2),
          juros: this.numberToReal(row.juros, 2),
          multa: this.numberToReal(row.multa, 2),
          valor_total: this.numberToReal(row.valor_total, 2),
          desconto: this.numberToReal(row.desconto, 2),
          status: this.onRowStatus(row, true),
        }))
        .filter((item) => item.status !== "Paga");
    },
    totalPagamento() {
      if (actionsStore.selectedRows.length === 0) return 0;
      return actionsStore.selectedRows.reduce(
        (acc, row) =>
          acc +
          parseFloat(row.valor) +
          parseFloat(row.juros) +
          parseFloat(row.multa) -
          parseFloat(row.desconto),
        0
      );
    },
    agrupamentoTableItems() {
      if (actionsStore.selectedRows.length === 0) return [];
      return actionsStore.selectedRows
        .map((row) => {
          const valor = parseFloat(row.valor || 0);
          const juros = parseFloat(row.juros || 0);
          const multa = parseFloat(row.multa || 0);
          const desconto = parseFloat(row.desconto || 0);
          const valorTotal =
            parseFloat(row.valor_total || 0) > 0
              ? parseFloat(row.valor_total || 0)
              : valor + juros + multa - desconto;

          return {
            documento: row.documento,
            cliente: row.cliente,
            vencimento: row.data_vencimento,
            pagamento: row.data_pagamento,
            valor: this.numberToReal(valor, 2),
            juros: this.numberToReal(juros, 2),
            multa: this.numberToReal(multa, 2),
            desconto: this.numberToReal(desconto, 2),
            valor_total: this.numberToReal(Math.max(valorTotal, 0), 2),
            status: this.onRowStatus(row, true),
          };
        })
        .filter((item) => item.status !== "Paga");
    },
    totalAgrupamento() {
      if (actionsStore.selectedRows.length === 0) return 0;
      const descontoAgrupamento = this._unmaskMoney(this.descontoAgrupamento);

      return Math.max(this.totalAgrupamentoBruto - descontoAgrupamento, 0);
    },
    totalAgrupamentoBruto() {
      if (actionsStore.selectedRows.length === 0) return 0;
      return actionsStore.selectedRows.reduce((acc, row) => {
        const valorTotal = parseFloat(row.valor_total || 0);

        if (valorTotal > 0) {
          return acc + valorTotal;
        }

        const valor = parseFloat(row.valor || 0);
        const juros = parseFloat(row.juros || 0);
        const multa = parseFloat(row.multa || 0);
        const desconto = parseFloat(row.desconto || 0);

        return acc + valor + juros + multa - desconto;
      }, 0);
    },
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getDataInit();
  },
};
</script>

<style>
.flatpickr-months .flatpickr-month,
.flatpickr-current-month .flatpickr-monthDropdown-months,
.flatpickr-weekdays,
span.flatpickr-weekday {
  background: var(--primary-color) !important;
}

.flatpickr-calendar.arrowTop:before {
  border-bottom-color: var(--primary-color) !important;
  color: var(--primary-color) !important;
}
#agruparContas___BV_modal_footer_ {
  display: flex;
  justify-content: space-between;
}
.agrupamento-info {
  align-items: center;
  background: #181c32;
  border-radius: 50%;
  color: #ffffff;
  display: inline-flex;
  font-size: 10px;
  font-weight: 700;
  height: 16px;
  justify-content: center;
  line-height: 16px;
  width: 16px;
}
</style>
